import { ReactComponent as ArrowRightIcon } from 'assets/icons/arrow-right.svg';
import { clsx } from 'clsx';

import type ISelectButton from './interfaces/ISelectButton';

import styles from './sass/SelectButton.module.scss';

function SelectButton({
  label,
  placeholder,
  onClick,
  className,
  name,
  error,
  required = false,
  disabled = false,
}: ISelectButton) {
  const classes = clsx(styles.selectButton, className, {
    [styles.disabled]: disabled,
    [styles.errorBorder]: error,
  });

  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <div className={styles.wrapper}>
      {label ? <span className={styles.label}>{required ? `${label}*` : label}</span> : null}
      <button
        className={classes}
        onClick={handleClick}
        type="button"
        aria-label={`${label}: ${placeholder}`}
        aria-disabled={disabled}
        disabled={disabled}
        name={name}
      >
        <span className={styles.placeholder}>{placeholder}</span>
        <ArrowRightIcon className={styles.arrow} />
      </button>
      {error ? <p className={styles.error}>{error}</p> : null}
    </div>
  );
}

export default SelectButton;
